import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

// Errors
import Page401 from '@/views/errors/Page401.vue';
import Page403 from '@/views/errors/Page403.vue';
import Page404 from '@/views/errors/Page404.vue';
import Page500 from '@/views/errors/Page500.vue';
import Page503 from '@/views/errors/Page503.vue';
import PrivacyPolicy from '@/views/errors/PrivacyPolicy.vue';

// Layouts
import EmptyLayout from '@/views/layouts/EmptyLayout.vue';
import AuthLayout from '@/views/layouts/AuthLayout.vue';
import DefaultLayout from '@/views/layouts/DefaultLayout.vue';

// Auth
import Login from '@/modules/core/auth/views/Login.vue';
import ForgotPassword from '@/modules/core/auth/views/ForgotPassword.vue';
import ResetPassword from '@/modules/core/auth/views/ResetPassword.vue';
import AuthAzure from '@/modules/core/auth/views/AuthAzure.vue';

// Routes
import CoreRoutes from '@/modules/core/common/routes';
import SaasRoutes from '@/modules/saas/common/routes';
import RenterRoutes from '@/modules/renter/common/routes';

const routes: Array<RouteRecordRaw> = [
    {
        // Strony błędów
        path: '/error',
        redirect: '/error/404',
        component: EmptyLayout,
        children: [
            {
                path: '401',
                name: 'error-401',
                component: Page401
            },
            {
                path: '403',
                name: 'error-403',
                component: Page403
            },
            {
                path: '404',
                name: 'error-404',
                component: Page404
            },
            {
                path: '500',
                name: 'error-500',
                component: Page500
            },
            {
                path: '503',
                name: 'error-503',
                component: Page503
            }
        ]
    },
    {
        path: '/auth',
        redirect: '/error/404',
        component: AuthLayout,
        children: [
            {
                path: 'login',
                name: 'login',
                meta: { auth: false },
                component: Login
            },
            {
                path: 'forgot-password',
                name: 'forgot-password',
                meta: { auth: false },
                component: ForgotPassword
            },
            {
                path: 'reset-password/:token',
                name: 'reset-password',
                meta: { auth: false },
                component: ResetPassword
            },
            {
                path: 'azure',
                name: 'auth-azure',
                meta: { auth: false },
                component: AuthAzure
            }
        ]
    },
    {
        path: '/renters/auth',
        redirect: '/error/404',
        component: AuthLayout,
        children: [
            {
                path: 'azure',
                name: 'auth-azure',
                meta: { auth: false },
                component: AuthAzure
            }
        ]
    },
    {
        path: '/',
        redirect: '/app/dashboard',
        component: DefaultLayout,
        children: [
            ...CoreRoutes,
            ...SaasRoutes,
            ...RenterRoutes
        ]
    },
    {
        path: '/polityka-prywatnosci',
        component: PrivacyPolicy,
    }
    // {
    //     // 404 Not found handler
    //     path: '/(.*)',
    //     redirect: '/error/404'
    // }
];

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes
});

export default router;
